const globals = {
  drillRunning: false,
  languageCode: null as string | null,
  languageTag: null as string | null,
  deviceId: null as string | null,
};

export default globals;
